import { PROFILE_GENDERS } from "./playerProfileConstants";

/**
 * Name already saved on the player. A placeholder or a bare email does not count
 * unless a first or last name was saved beside it.
 * @param {object | null | undefined} player
 * @returns {string}
 */
export function savedPlayerName(player) {
  const composed = [player?.firstName, player?.lastName]
    .map((part) => String(part || "").trim())
    .filter(Boolean)
    .join(" ");
  const display = String(player?.displayName || "").trim();
  const candidate = composed || display;
  if (!candidate || /^player$/i.test(candidate)) return "";
  if (!composed && candidate.includes("@")) return "";
  return candidate;
}

/**
 * Which of the mandatory identity fields are still empty.
 * @param {object | null | undefined} player
 * @returns {{ name: boolean, sex: boolean }}
 */
export function identityGaps(player) {
  if (!player) return { name: false, sex: false };
  return {
    name: !savedPlayerName(player),
    sex: !String(player.gender || "").trim(),
  };
}

/**
 * A new account needs a real name and sex before registration.
 * Age stays off this step.
 * @param {object | null | undefined} player
 */
export function playerNeedsNameAndSex(player) {
  const gaps = identityGaps(player);
  return gaps.name || gaps.sex;
}

/**
 * New accounts cannot continue until name, a profile gender, and date of birth are saved.
 * @param {object | null | undefined} player
 * @returns {{ name: boolean, sex: boolean, dob: boolean }}
 */
export function onboardingIdentityGaps(player) {
  const gender = String(player?.gender || "").trim().toLowerCase();
  const knownGender = PROFILE_GENDERS.some(
    (option) => option && option.toLowerCase() === gender
  );
  return {
    name: !savedPlayerName(player),
    sex: !knownGender,
    dob: !String(player?.dateOfBirth || "").trim(),
  };
}

/** @param {object | null | undefined} player */
export function playerNeedsOnboarding(player) {
  const gaps = onboardingIdentityGaps(player);
  return gaps.name || gaps.sex || gaps.dob;
}

/** Mixed doubles needs Male or Female on the entry, even if the profile says Prefer not to say. */
export function sexWorksForMixed(gender) {
  const value = String(gender || "").trim().toLowerCase();
  return value === "male" || value === "female";
}
